import { FulfillmentGroupDataSchema } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const watchFulfillmentGroups = unaryStreamRpc({
  name: "watchFulfillmentGroups",
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    maxUpdatedAt: z.date().nullish(),
  }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupDataSchema) }),
});
